import MuiButtonGroup from '@mui/material/ButtonGroup';
import { ButtonGroupProps } from './interface';
import React from 'react';
import { Button } from '../Button/Button.web';
import { useTheme } from '@mui/material/styles';

/**
 *
 * this component is not ready for use in production yet. it is one that will be done soon and will implement Button
 */
export const ButtonGroup = ({
  value: selected,
  onChange,
  options,
  ButtonProps = {},
  squared,
}: ButtonGroupProps) => {
  const theme = useTheme();
  const borderRadius = squared ? theme.spacing(0.5) : undefined;
  const style = (isSelected: boolean) => ({
    color: isSelected ? theme.palette.primary.main : 'grey.600',
    border: '1px solid',
    borderColor: 'rgba(0, 0, 0, 0.54)',
    '&:first-of-type': {
      borderTopLeftRadius: borderRadius,
      borderBottomLeftRadius: borderRadius,
    },
    '&:last-of-type': {
      borderTopRightRadius: borderRadius,
      borderBottomRightRadius: borderRadius,
    },
    // @ts-ignore
    ...ButtonProps.sx,
  });

  return (
    <MuiButtonGroup disableElevation>
      {options.map(({ value, label, disabled }) => {
        const isSelected = selected === value;
        return (
          <Button
            sx={style(isSelected)}
            // @ts-ignore
            variant={isSelected ? 'contained' : 'muted'}
            color={isSelected ? 'secondary' : undefined}
            isDisabled={disabled}
            key={value?.toString()}
            onClick={() => onChange(value)}
            {...ButtonProps}
          >
            {label}
          </Button>
        );
      })}
    </MuiButtonGroup>
  );
};
